import { useCallback } from 'react';

import { TServerSendRequest } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useGetPlayerLimitsInfo = () => {
    const send = useGenericSend();

    return useCallback(async (): Promise<Types.IGetPlayerLimitsInfoResponseData> => {
        const { data } = await send<TServerSendRequest, Types.IGetPlayerLimitsInfoResponseData>({
            ID: 31037,
            responses: [31038, 31039],
            description: 'Get player limits info'
        });

        return data;
    }, [
        send
    ]);
};
